import { default as index7MfM8rELYRMeta } from "/Users/nazaninreihani/auctria-one/packages/auctria-public-events/pages/index.vue?macro=true";
import { default as _91id_936In0aBCDhLMeta } from "/Users/nazaninreihani/auctria-one/packages/auctria-public-events/pages/preview/[id].vue?macro=true";
export default [
  {
    name: index7MfM8rELYRMeta?.name ?? "index",
    path: index7MfM8rELYRMeta?.path ?? "/",
    meta: index7MfM8rELYRMeta || {},
    alias: index7MfM8rELYRMeta?.alias || [],
    redirect: index7MfM8rELYRMeta?.redirect,
    component: () => import("/Users/nazaninreihani/auctria-one/packages/auctria-public-events/pages/index.vue").then(m => m.default || m)
  },
  {
    name: _91id_936In0aBCDhLMeta?.name ?? "preview-id",
    path: _91id_936In0aBCDhLMeta?.path ?? "/preview/:id()",
    meta: _91id_936In0aBCDhLMeta || {},
    alias: _91id_936In0aBCDhLMeta?.alias || [],
    redirect: _91id_936In0aBCDhLMeta?.redirect,
    component: () => import("/Users/nazaninreihani/auctria-one/packages/auctria-public-events/pages/preview/[id].vue").then(m => m.default || m)
  }
]